// Build a cache-busted absolute URL for any backend-served PDF.
// Adds ?v=<updated_at|created_at|timestamp> so the browser never re-uses a
// stale copy of a regenerated PDF (the filename stays the same after edits).
export function pdfUrl(item) {
  if (!item) return "";
  const rawPath = typeof item === "string" ? item : (item.pdf_url || "");
  if (!rawPath) return "";
  const backend = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
  const base = rawPath.startsWith("http")
    ? rawPath
    : backend
    ? `${backend}/${rawPath.replace(/^\/+/, "")}`
    : rawPath;
  const v = encodeURIComponent(
    (typeof item === "object" && (item.updated_at || item.created_at)) || Date.now()
  );
  const sep = base.includes("?") ? "&" : "?";
  return `${base}${sep}v=${v}`;
}

